import { render } from "./LeaveCarryForwardStatus.vue?vue&type=template&id=623da0ba"
import script from "./LeaveCarryForwardStatus.vue?vue&type=script&lang=js"
export * from "./LeaveCarryForwardStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__